import "babel-polyfill";
import "url-polyfill";



// WEBPACK FOOTER //
// ./src/polyfills.js